/* eslint-disable jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import { propTypes as StackNavigatorPropTypes } from '@components/StackNavigator/utils';

import styles from './tab.scss';

class AccordionTab extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    defaultExpanded: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    secondaryTitle: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    children: PropTypes.node.isRequired,
    toggleButtonId: PropTypes.string.isRequired,
    navigation: StackNavigatorPropTypes.navigation.isRequired
  };

  static defaultProps = {
    defaultExpanded: false
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.defaultExpanded,
      // TODO: This is not doing anything as of PR #1030 but
      // it'll be a key part of #1019. We'll revisit ths in that PR.
      isNeedToExpand: false
    };

    this.buttonRef = React.createRef();
    this.contentRef = React.createRef();
  }

  componentDidMount() {
    // TODO: This is not doing anything as of PR #1030 but
    // it'll be a key part of #1019. We'll revisit ths in that PR.
    if (this.props.navigation.focusElement === this.props.toggleButtonId) {
      this.setState(
        {
          isNeedToExpand: true
        },
        () => {
          this.buttonRef.current?.click();
        }
      );
    }
  }

  toggle = () => {
    this.setState(
      (state) => ({ ...state, expanded: !state.expanded }),
      () => {
        // TODO: This is not doing anything as of PR #1030 but
        // it'll be a key part of #1019. We'll revisit ths in that PR.
        if (this.state.expanded && this.state.isNeedToExpand) {
          const container = this.contentRef.current;
          if (container) {
            const focusable = container.querySelectorAll(
              'a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            focusable.length > 0 && focusable[0]?.focus();
          }
        }
      }
    );
  };

  handleKeyDown = (event) => {
    if (event && event.key === 'Enter') {
      event.preventDefault();
      this.toggle();
    }
  };

  render() {
    const { title, children, id, toggleButtonId, secondaryTitle } = this.props;
    const { expanded } = this.state;

    const iconClassName = expanded ? styles['icon-expand'] : styles['icon-close'];

    return (
      <div className={styles.wrapper}>
        <div className={styles.buttonContainer}>
          <button
            id={toggleButtonId}
            role="tab"
            type="button"
            ref={this.buttonRef}
            onClick={this.toggle}
            onKeyDown={this.handleKeyDown}
            aria-expanded={expanded}
            aria-controls={`accordion_content_${id}`}
            className={styles.button}>
            <Icon containerStyles={iconClassName} type={ICON_TYPES.ARROW_UP_CHEVRON} />
            <p dangerouslySetInnerHTML={{ __html: title }}></p>
          </button>
          <div className={styles.secondaryTitleContainer}>{secondaryTitle}</div>
        </div>
        {expanded && (
          <div id={`accordion_content_${id}`} ref={this.contentRef} className={styles.content}>
            {children}
          </div>
        )}
      </div>
    );
  }
}

export default AccordionTab;
